$(document).ready(function(){
    $('.js-filter-button').on('click', function(event) {
        console.log("button works");
        $('.js-shop-filters').toggle();

    });
});